// api.js

export const fetchSectionList = async (apiUrl,typeId, isHomePage, languageId) => {
    try {
        const response = await fetch(`${apiUrl}/api/section_list`, {
            method: 'POST',
            body: JSON.stringify({ type_id: typeId, is_home_page: isHomePage, language_id: languageId }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchBanner = async (apiUrl,typeId, isHomePage, languageId) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_banner`, {
            method: 'POST',
            body: JSON.stringify({ type_id: typeId, is_home_page: isHomePage, language_id: languageId }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchaSectionDetail = async (apiUrl,typeId, videoId, upcomingType, videoType) => {
    try {
        const response = await fetch(`${apiUrl}/api/section_detail`, {
            method: 'POST',
            body: JSON.stringify({ 'type_id': typeId, 'video_id': videoId, 'upcoming_type': upcomingType, 'video_type': videoType }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchVideoById = async (apiUrl,sessionId, showId) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_video_by_session_id`, {
            method: 'POST',
            body: JSON.stringify({ 'session_id': sessionId, 'show_id': showId }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchRentVideo = async (apiUrl,userId) => {
    try {
        const response = await fetch(`${apiUrl}/api/user_rent_video_list`, {
            method: 'POST',
            body: JSON.stringify({ 'user_id': userId }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};
export const fetchaddRentTransaction = async (apiUrl,userId, id, rentPrice, typeId, videoType, couponCode) => {

    try {
        const response = await fetch(`${apiUrl}/api/add_rent_transaction`, {
            method: 'POST',
            body: JSON.stringify({
                'user_id': userId,
                'video_id': id,
                'price': rentPrice,
                'type_id': typeId,
                'video_type': videoType,
                'unique_id': "couponCode"
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};


export const fetchGetPages = async (apiUrl) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_pages`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchGeneralSetting = async (apiUrl) => {
    try {
        const response = await fetch(`${apiUrl}/api/general_setting`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchGetTypes = async (apiUrl) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_type`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchLogin = async (apiUrl,Istype, Isemail) => {
    try {
        const response = await fetch(`${apiUrl}/api/login`, {
            method: 'POST',
            body: JSON.stringify({ type: Istype, email: Isemail }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchOTPdata = async (apiUrl,isPhoneNo, isEmail, isLoginType) => {
    try {
        const response = await fetch(`${apiUrl}/api/sendotp`, {
            method: 'POST',
            body: JSON.stringify({ mobile: isPhoneNo, email : isEmail, login_type : isLoginType }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchVerify = async (apiUrl,isPhoneNo, isEmail, isOTP) => {
    try {
        const response = await fetch(`${apiUrl}/api/verifyotp`, {
            method: 'POST',
            body: JSON.stringify({ mobile: isPhoneNo, email : isEmail, token: isOTP }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchGetProfile = async (apiUrl,uid) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_profile`, {
            method: 'POST',
            body: JSON.stringify({ id: uid }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchUpdateProfile = async (apiUrl,uid, phoneNumber, isEmail, isName) => {
    try {
        const response = await fetch(`${apiUrl}/api/update_profile`, {
            method: 'POST',
            body: JSON.stringify({ id: uid, name: isName }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchRentVideoList = async (apiUrl,typeId, isHomePage, languageId) => {
    try {
        const response = await fetch(`${apiUrl}/api/rent_video_list`, {
            method: 'POST',
            body: JSON.stringify({ type_id: typeId, is_home_page: isHomePage, language_id: languageId }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchPackage = async (apiUrl) => {
    try {
        const response = await fetch(`${apiUrl}/api/get_package`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};


export const fetchSearch = async (apiUrl,isName) => {
    try {
        const response = await fetch(`${apiUrl}/api/search_video`, {
            method: 'POST',
            body: JSON.stringify({ name: isName }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const fetchView = async (apiUrl,vid) => {
    try {
        const response = await fetch(`${apiUrl}/api/view-all`, {
            method: 'POST',
            body: JSON.stringify({ section_id: vid }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};


export const fetchCast = async (apiUrl,id) => {
    try {
        const response = await fetch(`${apiUrl}/api/cast_detail`, {
            method: 'POST',
            body: JSON.stringify({ 'cast_id': id }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};